import React from "react";
import { useFetchData } from "../../helpers/api";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import Swiper, { SwiperSlide } from "../../components/swiper";

const settings = {
  loop: true,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerView: 1,
  initialSlide: 1,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
};

const HomeHero = () => {
  const { data: bannerData, isLoading } = useFetchData(
    ["homeHeroBanners"],
    "/Customer/getHeroBanner",
    { id: 0 }
  );

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <div className="home_hero_banner_con">
        <Swiper options={settings}>
          {bannerData?.Data.map((banner) => (
            <SwiperSlide key={banner.ImgPath}>
              <img src={banner.ImgPath} alt="hero" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default HomeHero;
